import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconStage"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM19.5858 18L16.5858 15H7.41421L4.41421 18H19.5858Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStage;
